module.exports = __webpack_public_path__ + "static/media/pep-circle-parkplatz.f9588424.png";